import React, { Dispatch, SetStateAction, useState } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import Modal from '../modal/Modal';
import { BoldText, RegularText } from '../../lib/Text';
import { Col, Row } from '../../lib/utils';

// 회원에게 나갈 노쇼 알림 문구. 서버 계약상 기본(노쇼)은 키를 보내지 않는다.
export type NoShowNoticeType = 'NOSHOW' | 'SAME_DAY_CANCEL';

type Props = {
    setIsVisible: Dispatch<SetStateAction<boolean>>;
    onClickNoShow: (noticeType: NoShowNoticeType) => void;
    startTime?: string;
};

const ModalNoShowAlert = ({ setIsVisible, onClickNoShow, startTime }: Props) => {
    const [noticeType, setNoticeType] = useState<NoShowNoticeType>('NOSHOW');

    // 미리보기 날짜는 서버 푸시와 같은 형식(M월D일 dddd)
    const dateLabel = startTime ? dayjs(startTime).locale('ko').format('M월D일 dddd') : '';
    const datePrefix = dateLabel ? `${dateLabel} ` : '';

    const options: { value: NoShowNoticeType; label: string; title: string; body: string }[] = [
        {
            value: 'NOSHOW',
            label: '노쇼',
            title: '수업이 노쇼처리 되었어요!',
            body: `${datePrefix}수업 일정이 노쇼 처리되었어요.`,
        },
        {
            value: 'SAME_DAY_CANCEL',
            label: '당일 취소',
            title: '수업이 당일 취소 처리되었어요!',
            body: `${datePrefix}수업이 당일 취소로 처리되었어요.`,
        },
    ];

    return (
        <Modal setIsVisible={setIsVisible} whiteViewWidth={685} whiteViewHeight={530} borderRadius={25}>
            <Col className="p-[35px]">
                <BoldText fontSize={28} lineHeight={38} color="#3D4244" className="mb-[12px]">
                    노쇼로 변경하시겠습니까?
                </BoldText>
                <RegularText fontSize={20} lineHeight={30} color="#3D4244" className="mb-[24px]">
                    회원에게 아래 알림 중 하나가 전송됩니다.
                </RegularText>
                <div role="radiogroup" aria-label="회원에게 보낼 알림" className="flex flex-col gap-[12px]">
                    {options.map((option) => {
                        const isSelected = noticeType === option.value;
                        return (
                            <button
                                key={option.value}
                                type="button"
                                role="radio"
                                aria-checked={isSelected}
                                onClick={() => setNoticeType(option.value)}
                                className={`flex w-full items-start rounded-[14px] border-[2px] p-[16px] text-left ${
                                    isSelected ? 'border-[#3D73DD] bg-[#F3F7FE]' : 'border-[#E9ECEF] bg-white'
                                }`}
                            >
                                <span
                                    className={`mr-[14px] mt-[4px] flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full border-[2px] ${
                                        isSelected ? 'border-[#3D73DD]' : 'border-[#ADB5BD]'
                                    }`}
                                >
                                    {isSelected && <span className="h-[10px] w-[10px] rounded-full bg-[#3D73DD]" />}
                                </span>
                                <Col>
                                    <BoldText fontSize={20} lineHeight={28} color="#3D4244" className="mb-[6px]">
                                        {option.label}
                                    </BoldText>
                                    <RegularText fontSize={16} lineHeight={24} color="#495057">
                                        {option.title}
                                    </RegularText>
                                    <RegularText fontSize={16} lineHeight={24} color="#868E96">
                                        {option.body}
                                    </RegularText>
                                </Col>
                            </button>
                        );
                    })}
                </div>
                <Row className=" absolute bottom-0 right-0 p-[35px]">
                    <Col
                        className=" justify-center items-center w-[119px] h-[51px] bg-[#F2F4F6] rounded-[11px] cursor-pointer mr-[18px]"
                        onClick={() => setIsVisible(false)}
                    >
                        <RegularText fontSize={20} lineHeight={28} letterSpacing={-3} color="#3D4244">
                            아니오
                        </RegularText>
                    </Col>
                    <Col
                        className=" justify-center items-center w-[119px] h-[51px] bg-primary rounded-[11px] cursor-pointer"
                        onClick={() => onClickNoShow(noticeType)}
                    >
                        <RegularText fontSize={20} lineHeight={28} letterSpacing={-3} color="white">
                            네
                        </RegularText>
                    </Col>
                </Row>
            </Col>
        </Modal>
    );
};

export default ModalNoShowAlert;
